import { catchError, map, of, tap } from "rxjs";
import { LanguageService } from '@app/core/services/language.service';

export function translateFactory(service: LanguageService) {
  return () =>
    service.getList().pipe(
      tap(() => service.loadTranslations()),
      catchError(() => of(true)),
      map(() => true)
    );
}

